import { enGB as enLocale } from 'date-fns/locale/en-GB';
import { enUS as enUSLocale } from 'date-fns/locale/en-US';
import { ru as ruLocale } from 'date-fns/locale/ru';

export const locales = { en: enLocale, ru: ruLocale, enUS: enUSLocale };
